<template>
  <div class="mb-3">
    <label class="text-dark">{{ label }}</label>
    <div class="position-relative w-50">
      <input
        :type="type"
        :name="name"
        class="form-control"
        placeholder="XXXXXXXX"
      />

      <div
        role="button"
        @click="showPassword()"
        class="svg-icon password-icon position-absolute top-50 translate-middle"
      >
        <svg
        v-if="type == 'text'"
          xmlns="http://www.w3.org/2000/svg"
          width="22"
          height="16"
          viewBox="0 0 22 16"
        >
          <g id="Group_1295" data-name="Group 1295" transform="translate(0)">
            <path
              id="Shape"
              d="M11,14c4.043,0,6.918-2.592,8.6-4.751a2,2,0,0,0,0-2.5C17.918,4.592,15.043,2,11,2S4.082,4.592,2.4,6.751a2,2,0,0,0,0,2.5C4.082,11.408,6.957,14,11,14Zm10.136-3.506a4.03,4.03,0,0,0,0-4.988C19.3,3.158,15.926,0,11,0S2.7,3.158.864,5.506a4.03,4.03,0,0,0,0,4.988C2.7,12.842,6.074,16,11,16S19.3,12.842,21.136,10.494Z"
              fill="#3772ff"
              fill-rule="evenodd"
            />
            <path
              id="Shape-2"
              data-name="Shape"
              d="M5.664,4A1.946,1.946,0,0,1,3.776,6,1.946,1.946,0,0,1,1.888,4q0-.043,0-.085A1.342,1.342,0,0,0,2.36,4,1.46,1.46,0,0,0,3.776,2.5,1.578,1.578,0,0,0,3.7,2l.08,0A1.946,1.946,0,0,1,5.664,4ZM7.552,4A3.893,3.893,0,0,1,3.776,8,3.893,3.893,0,0,1,0,4,3.893,3.893,0,0,1,3.776,0,3.893,3.893,0,0,1,7.552,4Z"
              transform="translate(7.224 4)"
              fill="#3772ff"
              fill-rule="evenodd"
            />
          </g>
        </svg>
        <svg
        v-else
          xmlns="http://www.w3.org/2000/svg"
          width="22"
          height="16"
          viewBox="0 0 22 16"
        >
          <g id="Group_1295" data-name="Group 1295" transform="translate(0)">
            <path
              id="Shape"
              d="M11,14c4.043,0,6.918-2.592,8.6-4.751a2,2,0,0,0,0-2.5C17.918,4.592,15.043,2,11,2S4.082,4.592,2.4,6.751a2,2,0,0,0,0,2.5C4.082,11.408,6.957,14,11,14Zm10.136-3.506a4.03,4.03,0,0,0,0-4.988C19.3,3.158,15.926,0,11,0S2.7,3.158.864,5.506a4.03,4.03,0,0,0,0,4.988C2.7,12.842,6.074,16,11,16S19.3,12.842,21.136,10.494Z"
              fill="#777e90"
              fill-rule="evenodd"
            />
            <path
              id="Shape-2"
              data-name="Shape"
              d="M5.664,4A1.946,1.946,0,0,1,3.776,6,1.946,1.946,0,0,1,1.888,4q0-.043,0-.085A1.342,1.342,0,0,0,2.36,4,1.46,1.46,0,0,0,3.776,2.5,1.578,1.578,0,0,0,3.7,2l.08,0A1.946,1.946,0,0,1,5.664,4ZM7.552,4A3.893,3.893,0,0,1,3.776,8,3.893,3.893,0,0,1,0,4,3.893,3.893,0,0,1,3.776,0,3.893,3.893,0,0,1,7.552,4Z"
              transform="translate(7.224 4)"
              fill="#777e90"
              fill-rule="evenodd"
            />
          </g>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "@vue/reactivity";
export default {
  props: ["label", "name"],
  setup() {
    const type = ref("password");
    const showPassword = () => {
      if (type.value === "password") {
        type.value = "text";
      } else {
        type.value = "password";
      }
    };
    return { type, showPassword };
  },
};
</script>

<style>
</style>